module.exports = __webpack_public_path__ + "static/media/lecture.5738d6f5.jpg";